// extracted by mini-css-extract-plugin
export default {"score":"LeadScore_score__E1O-s","booked":"LeadScore_booked__2m6tw","hot":"LeadScore_hot__URBqh","warm":"LeadScore_warm__TXkfV","low":"LeadScore_low__QYaWl"};